<div class="account-submenu-header">
  <h3 class="account-submenu-title">{{ title }}</h3>
  <div class="account-submenu-wrapper">
    <div *ngIf="!hideContainer" class="account-submenu-container">
      <div class="account-submenu-content">
        <div class="account-submenu-item-wrapper">
          <div class="account-submenu-items">
            <a
              *ngFor="let item of accountSubmenuItems"
              routerLink="{{ item.routerLink }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              class="account-submenu-item"
              (click)="onSubmenuItemClick(item.routerLink)"
            >
              <svg-icon
                *ngIf="item.icon"
                [svgPath]="item.icon"
                [attr.aria-label]="item.title"
                class="account-submenu-item-icon"
              ></svg-icon>
              <span class="account-submenu-item-title">{{ item.title | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="account-submenu-page">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
